module.exports = __webpack_public_path__ + "2a41b3b9.png";